import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudTasks = () => import('./staff/crudTasks')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'TasksStaffDashboard',
  crudTasks: 'TasksStaffCrud',
}

const router =
  [
    {
      path: '/st/tasks',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Tareas',
          }
        },
        {
          path: 'list/:taskId?',
          name: VIEWS.crudTasks,
          component: ViewStaffCrudTasks,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Mis Tareas',
          }
        },
      ]
    },
  ]

export default router
export { VIEWS }
